export default "__VITE_ASSET__PVlmLwJ6FyCLdcCAHHh9dg__"